// File: components/LoginScreen.js
import React, { useState } from 'react';

const LoginScreen = ({ onLogin, loginScreenInfo, isVerifying }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = () => {
    onLogin(password);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">{loginScreenInfo.title}</h1>
        <p className="mb-4 text-gray-600 text-center">{loginScreenInfo.subtitle}</p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 mb-4 border rounded"
          placeholder={loginScreenInfo.passwordPlaceholder}
          onKeyPress={(e) => e.key === 'Enter' && !isVerifying && handleSubmit()}
          disabled={isVerifying}
        />
        <button
          onClick={handleSubmit}
          className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 disabled:opacity-50"
          disabled={isVerifying}
        >
          {isVerifying ?
            <span className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Verifying...
            </span> :
            loginScreenInfo.loginButtonText
          }
        </button>
      </div>
    </div>
  );
};

export default LoginScreen;